import { subscriptionApi } from '@app/features/subscription';
import { autoApi } from '@entities/Auto';
import { productAvailabilityInTheStoresApi } from '@features/productAvailabilityInTheStores';
import { kladerApi } from '@redux/api/Klader';
import { catalogApi } from '@entities/Catalog';
import { actionApi } from '@entities/Actions';
import { seoApi } from '@entities/Seo';
import { apiUser } from '@entities/User';

export const combineMiddleware = getDefaultMiddleware =>
  getDefaultMiddleware().concat(
    kladerApi.middleware,
    subscriptionApi.middleware,
    productAvailabilityInTheStoresApi.middleware,
    autoApi.middleware,
    catalogApi.middleware,
    actionApi.middleware,
    seoApi.middleware,
    apiUser.middleware,
  );
